/**
 * Created by mateimisarca on 30/12/2019
 */

import PasswordReset from './password-reset';

export default PasswordReset;
